import { lazy } from "react";

export const LazyProductLayoutElement = lazy(() =>
  import(
    "@faire/retailer-visitor-shared/views/product/ProductLayoutElements/ProductLayoutElements"
  ).then((m) => ({
    default: m.ProductLayoutElements,
  }))
);
